const lensflare = [
  [ 0, 0.1, -0.45, [0.6, 0.5, 0.35], 0.1 ],
  [ 0, 0.5, -0.45, [0.6, 0.5, 0.35], 0.1 ],
  [ 0, 1.0, -0.40, [0.5, 0.35, 0.6], 0.1 ],
  [ 0, 0.5, -0.25, [0.6, 0.35, 0.5], 0.1 ],
  [ 0, 1.0, -0.20, [0.35, 0.6, 0.5], 0.1 ],
  [ 0, 0.5, -0.55, [0.6, 0.5, 0.35], 0.1 ],
  [ 0, 0.5, -0.50, [0.5, 0.35, 0.5], 0.1 ],
  [ 1, 1.0, -0.35, [0.6, 0.35, 0.5], 0.1 ],
  [ 0, 0.5, -0.30, [0.35, 0.6, 0.5], 0.1 ],
  [ 0, 1.0, -0.15, [0.6, 0.5, 0.35], 0.1 ],
  [ 0, 0.5, -0.10, [0.5, 0.35, 0.6], 0.1 ],
  [ 0, 1.5, 0.10, [0.6, 0.35, 0.5], 0.1 ],
  [ 0, 0.5, 0.15, [0.35, 0.6, 0.5], 0.1 ],
  [ 0, 0.5, 0.30, [0.5, 0.35, 0.5], 0.1 ],
  [ 1, 1.0, 0.35, [0.6, 1.0, 0.35], 0.1 ],
  [ 0, 1.0, 0.50, [0.4, 0.35, 0.6], 0.1 ],
  [ 0, 0.5, 0.55, [0.6, 1.0, 0.35], 0.1 ],
  [ 0, 0.5, 0.70, [0.6, 0.35, 0.6], 0.1 ],
  [ 1, 1.5, 0.75, [0.5, 0.35, 0.6], 0.1 ],
  [ 0, 0.5, 0.60, [0.6, 1.0, 0.35], 0.1 ],
  [ 0, 0.5, 0.50, [0.35, 0.5, 0.6], 0.1 ],
  [ 0, 0.5, 0.55, [0.35, 1.0, 0.5], 0.1 ],
  [ 0, 1.0, 1.30, [0.6, 0.5, 0.35], 0.1 ],
  [ 0, 1.0, 1.35, [0.5, 0.35, 0.5], 0.1 ],
  [ 0, 0.5, 1.50, [0.6, 0.35, 0.5], 0.1 ],
  [ 0, 1.0, 1.55, [0.35, 1.0, 0.6], 0.1 ],
  [ 1, 0.5, 1.70, [0.35, 0.6, 0.5], 0.1 ],
  [ 0, 1.5, 1.75, [0.3,  1.0, 0.6], 0.1 ],
  [ 0, 0.5, 0.50, [0.35, 1.0, 0.6], 0.1 ],
  [ 0, 0.5, 2.15, [0.5, 0.35, 0.6], 0.1 ],
  [ 0, 1.0, 2.30, [0.6, 0.35, 0.5], 0.1 ],
  [ 0, 0.5, 2.35, [0.6, 0.5, 0.35], 0.1 ],
  [ 0, 1.0, 2.50, [0.6, 0.5, 0.35], 0.1 ],
  [ 1, 1.5, 2.55, [0.5, 0.35, 0.6], 0.1 ],
  [ 0, 1.0, 2.70, [0.6, 0.35, 0.5], 0.1 ],
  [ 0, 0.5, 2.75, [0.35, 1.0, 0.6], 0.1 ],
  [ 0, 0.5, 3.00, [0.6, 0.5, 0.35], 0.1 ],
  [ 0, 0.5, 3.15, [0.5, 0.35, 0.5], 0.1 ],
  [ 1, 0.5, 3.35, [0.35, 0.6, 0.5], 0.1 ],
  [ 0, 0.9, 3.50, [0.6, 0.5, 0.35], 0.1 ],
  [ 0, 1.3, 3.55, [0.35, 1.0, 0.6], 0.1 ],
  [ 0, 2.3, 3.70, [0.6, 0.35, 0.5], 0.1 ],
  [ 0, 2.6, 3.75, [0.5, 0.35, 0.5], 0.1 ],
  [ 0, 0.2, 3.9, [0.35, 1.0, 0.6], 0.1 ],
  [ 2, 0.6, 4.20, [0.3, 0.5, 0.65], 0.1 ],
  [ 0, 0.8, 5.1, [0.7, 0.35, 0.2], 0.1 ],
  [ 1, 1.5, 4.9, [0.45, 0.3, 0.6], 0.1 ],
  [ 2, 1.7, 3.82, [0.5, 0.5, 0.5], 0.02 ],
  [ 0, 0.5, -0.47, [0.6, 0.5, 0.35], 0.1 ],
  [ 0, 1.5, -0.22, [0.35, 0.6, 0.5], 0.1 ],
  [ 0, 0.5, -0.53, [0.6, 0.5, 0.35], 0.1 ],
  [ 0, 1.5, -0.31, [0.6, 0.35, 0.5], 0.1 ],
  [ 1, 0.5, 0.32, [0.5, 0.35, 0.5], 0.1 ],
  [ 2, 0.4, 0.52, [0.4, 0.35, 0.6], 0.1 ],
  [ 0, 0.6, 0.72, [0.5, 0.35, 0.6], 0.1 ],
  [ 0, 0.7, 1.32, [0.5, 0.35, 0.5], 0.1 ],
  [ 1, 0.4, 1.57, [0.35, 1.0, 0.6], 0.1 ],
  [ 0, 0.5, 2.20, [0.35, 1.0, 0.6], 0.1 ],
  [ 0, 0.6, 2.60, [0.6, 0.35, 0.5], 0.1 ],
  [ 0, 0.5, 2.52, [0.5, 0.35, 0.6], 0.1 ],
  [ 2, 1.0, 2.79, [0.35, 1.0, 0.6], 0.1 ],
  [ 1, 1.5, 2.90, [0.6, 0.35, 0.5], 0.1 ],
  [ 0, 1.5, 3.54, [0.6, 0.5, 0.35], 0.1 ],
  [ 0, 1.5, 3.72, [0.5, 0.35, 0.5], 0.1 ],
  [ 2, 9.0, 0.2, [0.6, 0.6, 0.6], 0.1 ],
  [ 2, 9.0, 0.0, [0.6, 0.6, 0.6], 0.05 ],
  [ 2, 9.0, 0.0, [0.6, 0.6, 0.6], 0.05 ],
  [ 4, 4.0, 0.0, [1.0, 1.0, 1.0], 0.08]
];

export default lensflare;
